import { rawIcons as o } from "./raw-icons.js";
const r = Object.keys(o).map((t) => {
  const [e, l] = t.split("/");
  return {
    // Prefix the src with the group so that the final flat icon map has unique keys
    src: t,
    title: l.replaceAll("-", " "),
    group: e,
    tags: []
  };
}).filter(({ group: t }) => ["custom", "brand", "line", "solid"].includes(t));
export {
  r as localIconList
};
